export const HIGHLIGHTED_TICKERS = new Set(["QQQ", "SPY", "IWM", "DIA", "VIX"]);

export const SYMBOL_ALIAS: Record<string, string> = {
  "S&P500": "SPY",
};

export function resolveSymbol(symbol: string): string {
  return SYMBOL_ALIAS[symbol] ?? symbol;
}

const TRADINGVIEW_SYMBOL_OVERRIDE: Record<string, string> = {
  BTC: "AMEX:BTC",
  ETH: "AMEX:ETH",
};

export function resolveTradingViewSymbol(symbol: string): string {
  const key = symbol.replace(/^\$/, "").toUpperCase();
  return TRADINGVIEW_SYMBOL_OVERRIDE[key] ?? symbol;
}

const TYPE_BG_COLORS: Record<string, string> = {
  stock: "#FFFFFF",
  etf: "#F5F5F5",
  index: "#EFEFEF",
};

export function getTypeBg(type: string): string {
  const key = type?.toLowerCase() ?? "";
  for (const [pattern, color] of Object.entries(TYPE_BG_COLORS)) {
    if (key.includes(pattern)) return color;
  }
  return "#FFFFFF";
}
